import { createSlice } from "@reduxjs/toolkit";
import { fetchAboutUs } from "../actions/aboutUsAction";

const initialState = {
  data: null,
  isLoading: false,
  error: null,
};

const aboutUsSlice = createSlice({
  name: "aboutUs",
  initialState,
  reducers: {
    clearAboutUs: (state) => {
      state.data = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAboutUs.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchAboutUs.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload.data[0]; // Get the first item from the array
        state.error = null;
      })
      .addCase(fetchAboutUs.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload?.message || "Failed to fetch about us data";
      });
  },
});

export const { clearAboutUs } = aboutUsSlice.actions;
export default aboutUsSlice.reducer;